import {InvitationStatusApp} from "../Functionality/InvitationStatusApp";
import RequestInvitationHeader from "./RequestInvitationHeader";
import CustomExpandableTable from "../../../../../components/table/CustomExpandableTable";
import React from "react";
import RenderExpandedRow from "./RenderExpandedRow";
import ConfirmModal from "../../Invitation/Modal/ConfirmModal";
import {INVITATION_VIEW_TYPE} from "../../Invitation/Model/Model";
import NotInformation from "../../../../../components/NotInformation";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */

const InvitationStatus = (props) => {
    const {
        selectedList,
        setSelectedList,
        subView,
        handleSubViewChange,
        setCriteria,
        setBodyForExport,
        searchElement,
        setSearchElement,
        finalArray,
        setFinalArray,
        search,
        setSearch,
        modified,
        setModified
    } = props;

    const {
        columns,
        handleRowExpand,
        handleCheckboxChange,
        handleDeleteAll,
        pagination,
        results,
        DEV,
        permission,
        setResults,
        option,
        page,
        rowsPerPage,
        userId,
        RenderOptionsMenu,
        searchId,
        setSimpleSearch,
        showCancel,
        setShowCancel,
        cancelRequest,
        itemsToCancel,
        setItemsToCancel,
        t
    } = InvitationStatusApp({
        selectedList,
        setSelectedList,
        searchElement,
        finalArray,
        setSearch,
        setCriteria,
        setBodyForExport,
        modified,
        setModified
    });

    return (
        <>
            <RequestInvitationHeader
                subView={subView}
                handleSubViewChange={handleSubViewChange}
                searchId={searchId}
                setBodyForExport={setBodyForExport}
                setSearchResults={setResults}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                option={option}
                page={page}
                rowsPerPage={rowsPerPage}
                setSimpleSearch={setSimpleSearch}
                search={search}
                setSearch={setSearch}
                finalArray={finalArray}
                setFinalArray={setFinalArray}
                DEV={DEV}
                permission={permission}
                userId={userId}
                viewType={INVITATION_VIEW_TYPE.INVITATION_STATUS}
            />

            {results?.content?.length > 0 ? (
                <div className={"mt-3"}>
                    {/**Done*/}
                    <CustomExpandableTable
                        columns={columns}
                        rows={results?.content}
                        renderExpandedRow={RenderExpandedRow}
                        renderOptionsMenu={RenderOptionsMenu}
                        checkbox={false}
                        onRowExpand={handleRowExpand}
                        selectedList={selectedList}
                        handleCheckboxChange={handleCheckboxChange}
                        handleDeleteAll={handleDeleteAll}
                        rowsPerPage={rowsPerPage}
                    />
                    {pagination()}
                </div>
            ) : (
                <NotInformation
                    className={"mt-4"}
                    text={t('no_information')}
                    card={true}
                />
            )}

            <ConfirmModal
                show={showCancel}
                onHide={() => {
                    setShowCancel(false);
                    setItemsToCancel([]);
                }}
                onClickFn={() => {
                    cancelRequest(itemsToCancel);
                    setShowCancel(false);
                }}
                title_modal={'cancel_invitation'}
                isReset={() => setItemsToCancel([])}
                description={t("are_you_sure_you_want_to_cancel_the_invitation")}
            />

        </>
    );
};
export default InvitationStatus
